import { jsx as _jsx } from "react/jsx-runtime";
import { Option } from '@ingka/select';
export default ({ name, value, disabled }) => {
    return _jsx(Option, { name: name, value: value, disabled: disabled });
};
//# sourceMappingURL=SkapaOption.js.map